import React  from "react";
import JobRoleTable from "./components/JobRoleTable";
import { connect } from "react-redux";

const JobRoles = () => {
	
	return (
	    <div>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">      		
				<JobRoleTable />
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoles);